import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import arIcon from '../../assests/ArServicesImg/arIcon.svg'; 
import vrIcon from '../../assests/ArServicesImg/vrIcon.svg';

import './ARVRSecondpage.css';

const ARVRSecondpage: React.FC = () => {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <div className="container-arvr-second text-center">
        {/* Title & Subtitle */}
        <h2 className="second-h2 mb-1">Performance & Efficiency at Scale</h2>
        <p className="mb-5 second-p">
          Save money | Boost productivity | Scale with confidence.
        </p>

        {/* Cards Row */}
        <div className="row justify-content-between gap-4 align-items-stretch">
          
          {/* AR Card */}
          <div className="col-md-5-5 d-flex">
            <div className="app-card ar-card p-4 shadow-sm text-start h-100 w-100">
              <div className="d-flex align-items-center mb-3">
                <img src={arIcon} alt="AR Icon" className="app-icon me-2" />
                <h5 className="mb-0 second-h5">XR Prototyping & Trials </h5>
              </div>
              <ul className="text-muted second-ul">
                <li>
                  Conduct <span className="bold-span">rapid XR prototyping</span> 
                  to test concepts before full-scale deployment.
                </li>
                <li>
                  Validate ROI and adoption potential with
                  <span className="bold-span"> immersive technology trials</span>.
                </li>
              </ul>
            </div>
          </div>

          {/* VR Card */}
          <div className="col-md-5-5 d-flex">
            <div className="app-card vr-card p-4 shadow-sm text-start h-100 w-100">
              <div className="d-flex align-items-center mb-3">
                <img src={vrIcon} alt="VR Icon" className="app-icon me-2" />
                <h5 className="mb-0 second-h5">Data Visualization in XR</h5>
              </div>
              <ul className="text-muted second-ul">
                <li>
                  Transform <span className="bold-span">complex datasets into interactive 3D visualizations</span> 
                  for intuitive insights.
                </li>
                <li>
                  Enable faster decision-making with 
                  <span className="bold-span"> immersive data exploration tools</span>.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ARVRSecondpage;
